/**
 * Launcher 다운로드 URL.
 * @description Hoya 전용 빌드 — GitHub Releases 호스팅 (직접 다운로드 보장).
 *  hero / SectionDownload 등 모든 다운로드 버튼이 동일 링크를 사용.
 */
export const LAUNCHER_DOWNLOAD_URL =
  'https://github.com/hoyapc-co-kr/hoyapc-connector/releases/latest/download/HoyaPC-Connector-PC.msi';
